import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { SccButton } from '@/components/atoms';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import BottomSheet from '@/modals/BottomSheet';
import { BUILDING_REGISTRATION_CONTENT, } from '../constants';
export default function BuildingRegistrationBottomSheet({ isVisible, event, onPressCancel, onPressConfirm, }) {
    const content = BUILDING_REGISTRATION_CONTENT[event];
    return (_jsx(LogParamsProvider, { params: {
            bottom_sheet_type: 'building_registration',
            registration_event: event,
        }, children: _jsx(BottomSheet, { isVisible: isVisible, children: _jsxs(Container, { children: [_jsxs(TitleSection, { children: [_jsx(Title, { children: content.title }), _jsx(Description, { children: content.description })] }), _jsx(ImageContainer, { children: _jsx(StyledImage, { source: content.imagePath, resizeMode: "contain" }) }), _jsxs(ButtonContainer, { children: [_jsx(SccButton, { text: content.cancelButtonText, textColor: "black", buttonColor: "gray10", fontFamily: font.pretendardMedium, onPress: onPressCancel, elementName: "building_registration_cancel", style: { maxWidth: 132, width: '100%' } }), _jsx(SccButton, { text: content.confirmButtonText, textColor: "white", buttonColor: "brandColor", fontFamily: font.pretendardBold, onPress: onPressConfirm, elementName: "building_registration_confirm", style: { flex: 1 } })] })] }) }) }));
}
const Container = styled.View `
  padding: 32px 20px 20px;
  gap: 24px;
`;
const TitleSection = styled.View `
  gap: 4px;
`;
const Title = styled.Text `
  font-size: 22px;
  line-height: 30px;
  font-family: ${font.pretendardBold};
  color: ${color.gray80};
  text-align: center;
`;
const Description = styled.Text `
  font-size: 18px;
  line-height: 26px;
  color: ${color.gray70};
  text-align: center;
`;
const ImageContainer = styled.View `
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: -11px;
`;
const StyledImage = styled.Image `
  width: 100%;
  height: auto;
  aspect-ratio: 375 / 265;
  max-height: 300px;
`;
const ButtonContainer = styled.View `
  flex-direction: row;
  gap: 12px;
  margin-top: 24px;
`;
